module.exports = __webpack_public_path__ + "static/media/aave_v2.e0314d2e.svg";